export default __webpack_public_path__ + "static/media/use_action_zc.204bb352.png";